<script setup>
import { ref } from 'vue'
import BcsModal from '../BcsModal.vue'

const props = defineProps({
  title: { type: String, default: '' },
  body: { type: String, default: '' },
  confirmLabel: { type: String, default: 'Confirm' },
  cancelLabel: { type: String, default: 'Cancel' },
  modalType: { type: String, default: 'confirmation' },
  isProcessing: { type: Boolean, default: false }
})

const emit = defineEmits(['confirm', 'cancel'])

const modalRef = ref(null)

function openModal() {
  modalRef.value.openModal()
}

function closeModal() {
  modalRef.value.closeModal()
}

function onConfirm() {
  emit('confirm')
}

function onCancel() {
  closeModal()
  emit('cancel')
}

defineExpose({ openModal, closeModal })
</script>

<template>
  <BcsModal
    ref="modalRef"
    modalSize="small"
    :modalType="modalType"
    :hideCloseButton="true"
    :showFooter="false"
    @closeButtonClicked="onCancel"
  >
    <template #body-header>
      <div class="pt-4">
        <p class="header-24 fw-bold">{{ title }}</p>
      </div>
    </template>
    <p class="mb-4 text-14">{{ body }}</p>

    <template #footer-body>
      <div class="d-flex flex-column align-items-center gap-2 mt-1">
        <button
          type="button"
          class="btn btn-primary fw-medium px-4"
          :disabled="isProcessing"
          @click="onConfirm"
        >
          {{ confirmLabel }}
          <span v-if="isProcessing" class="spinner-border spinner-border-sm ms-2" role="status"></span>
        </button>
        <button
          type="button"
          class="btn text-primary fw-bold"
          :disabled="isProcessing"
          @click="onCancel"
        >
          {{ cancelLabel }}
        </button>
      </div>
    </template>
  </BcsModal>
</template>
